module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_0.a5ef53fc.png";